import { jwtDecode } from 'jwt-decode';
import { JWTDecodedToken } from '../types/auth';

/**
 * Impersonación desde cuarteto: el token de `/hack-token` (comparsa) es el MISMO que el del
 * login del usuario, más `canBypassMaintenance: true`, que ningún otro token lleva. Durante una
 * impersonación no se registra nada en PostHog (`analytics.startImpersonation`).
 */
export const esTokenDeImpersonacion = (token: string): boolean => {
	try {
		return jwtDecode<JWTDecodedToken>(token)?.canBypassMaintenance === true;
	} catch {
		return false;
	}
};

/**
 * Si la app se está abriendo por `/token` con un token de impersonación. Se mira al cargar,
 * antes de iniciar PostHog: la página vista inicial sale en el `init`, antes de que el login
 * llegue a hacer el opt-out.
 */
export const esEntradaDeImpersonacion = (): boolean => {
	if (window.location.pathname !== '/token') return false;
	const token = new URLSearchParams(window.location.search).get('token');
	return token !== null && esTokenDeImpersonacion(token);
};
